// extracted by mini-css-extract-plugin
module.exports = {"register-form":"Register_register-form__1os3e","other":"Register_other__3qmbK"};